export const splitStringByComma = (inputString: string): string[] => {
  if (inputString?.includes(",")) {
    const stringArray: string[] = inputString.split(",");
    return stringArray;
  } else {
    return [inputString];
  }
};

export function capitalizeWords(input: string): string {
  // Split the input string into words
  const words = input?.split(" ");

  // Capitalize the first letter of each word and join them back
  const capitalizedWords = words?.map((word) => {
    if (word.length > 0) {
      return word[0]?.toUpperCase() + word?.slice(1)?.toLowerCase();
    }
    return "";
  });

  // Join the capitalized words with spaces to form the final string
  const result = capitalizedWords?.join(" ");

  return result;
}

export const splitStringByDash = (inputString: string): string[] => {
  if (inputString?.includes("-")) {
    const stringArray: string[] = inputString.split("-");
    return stringArray;
  } else {
    return [inputString];
  }
};

export const trimStringBeforeWord = (
  inputString: string,
  word: string
): string => {
  const index = inputString.indexOf(word);
  if (index !== -1) {
    return inputString.slice(0, index);
  } else {
    return inputString;
  }
};

export const getStringBetweenWords = (
  inputString: string,
  word1: string,
  word2: string
): string => {
  const index1 = inputString.indexOf(word1);
  const index2 = inputString.indexOf(word2);
  if (index1 !== -1 && index2 !== -1 && index2 > index1) {
    return inputString.slice(index1 + word1.length, index2).trim();
  } else {
    return "";
  }
};

export const getFirstImage = (
  carImages: {
    imageUrl: string;
    videoUrl: string;
  }[]
) => {
  if (carImages[0]) {
    // const images = splitStringByComma(vehicle?.carImages[0]?.imageUrl);
    const imgArr = carImages?.filter((image: any) => image.imageUrl);
    const imgMap = imgArr.map((image: any) => image.imageUrl);
    const imgArrs = new Set(imgMap);

    // console.log(images);
    return Array.from(imgArrs)[0] as string;
  }
};

/**
 * The `stripHtml` function in TypeScript removes HTML tags from a given string.
 * @param {string} html - The `stripHtml` function takes a string `html` as input, which represents an
 * HTML content that may contain HTML tags. The function is designed to remove all HTML tags from the
 * input string and return the cleaned text without any HTML tags.
 * @returns An empty string is being returned if no HTML tags are found in the input `html` string. If
 * HTML tags are found, they are replaced with an empty string and the modified string is returned.
 */
export const stripHtml = (html: string) => {
  // Check if the string contains any HTML tags
  if (!/<[^>]*>?/.test(html)) {
    // If no HTML tags are found, return an empty string
    return "";
  }
  // If HTML tags are found, replace them with an empty string
  return html.replace(/<[^>]*>?/gm, "");
};
